import type { PropType } from 'vue';
import type { TContent } from '~/types/common';

import ErrorBoundary from '@devhacker/shared/components/ErrorBoundary.vue';
import { createVNode } from '~/utils/content-parser';
import { useAmpCustomElement } from '@devhacker/shared/composables/useAmpCustomElement';

export default defineNuxtComponent({
  name: 'TheContent',

  props: {
    elem: {
      type: Object as PropType<TContent>,
      required: true,
    },
  },

  setup(props) {
    // Не имеет отдельного компонента, рендерится через default
    // Потому подключаем элемент в the content
    if (props.elem.type === 'amp-viqeo-player') {
      useAmpCustomElement('amp-viqeo-player');
    }

    return () =>
      h(
        ErrorBoundary,
        { moduleName: 'TheContent' },
        {
          default: () => {
            try {
              return createVNode(props.elem, h);
            } catch (err) {
              console.warn(err);
              return null;
            }
          },
        },
      );
  },
});
